import axios from "../utils/axios";

export const getAllClasses = async (page = 1, per_page = 15, filters = {}) => {
    const params = { ...filters };
    if (page) params.page = page;
    if (per_page) params.per_page = per_page;
    const { data } = await axios.get('/classes', { params });
    return data;
};

export const getClassesForSelect = async () => {
    const { data } = await axios.get('/classes/for-select');
    return data;
};

export const getClass = async (id) => {
    const { data } = await axios.get(`/classes/${id}`);
    return data;
};

export const createClass = async (req) => {
    const { data } = await axios.post('/classes', req, { headers: { Accept: 'application/json' } });
    return data;
};

export const updateClass = async (req, id) => {
    const { data } = await axios.put(`/classes/${id}`, req, { headers: { Accept: 'application/json' } });
    return data;
};

export const deleteClass = async (id) => {
    const { data } = await axios.delete(`/classes/${id}`, { headers: { Accept: 'application/json' } });
    return data;
};

export const deleteAllClasses = async (req) => {
    const { data } = await axios.delete('/classes/mass-destroy', { data: req, headers: { Accept: 'application/json' } });
    return data;
};

export const forceDeleteClass = async (id) => {
    const { data } = await axios.delete(`/classes/${id}/force-delete`, { headers: { Accept: 'application/json' } });
    return data;
};

export const forceDeleteAllClasses = async (ids) => {
    const { data } = await axios.delete('/classes/mass-force-delete', { data: ids, headers: { Accept: 'application/json' } });
    return data;
};

export const restoreClass = async (id) => {
    const { data } = await axios.post(`/classes/${id}/restore`, {}, { headers: { Accept: 'application/json' } });
    return data;
};

export const restoreAllClasses = async (req) => {
    const { data } = await axios.post('/classes/mass-restore', req, { headers: { Accept: 'application/json' } });
    return data;
};
